import React, { useCallback, useEffect, useState } from "react";
import versionCargada from "../version.json";

const CADA = 5 * 60 * 1000;

const identidadDe = (version) => {
  if (!version?.sha) return null;
  return `${version.sha}:${version.compilado || ""}`;
};

const AvisoVersionNueva = () => {
  const [versionNueva, setVersionNueva] = useState(null);
  const [versionDescartada, setVersionDescartada] = useState(null);

  const revisar = useCallback(async () => {
    if (versionNueva) return;

    try {
      const respuesta = await fetch(
        `${process.env.PUBLIC_URL}/version.json?t=${Date.now()}`,
        { cache: "no-store" }
      );
      if (!respuesta.ok) return;

      const desplegada = await respuesta.json();
      const identidadDesplegada = identidadDe(desplegada);

      if (
        identidadDesplegada &&
        identidadDesplegada !== identidadDe(versionCargada) &&
        identidadDesplegada !== versionDescartada
      ) {
        setVersionNueva(desplegada);
      }
    } catch (error) {
      // Sin red o durante un despliegue incompleto no se muestra un falso aviso.
    }
  }, [versionDescartada, versionNueva]);

  useEffect(() => {
    revisar();
    const reloj = setInterval(revisar, CADA);
    const alVolver = () => document.visibilityState === "visible" && revisar();
    document.addEventListener("visibilitychange", alVolver);

    return () => {
      clearInterval(reloj);
      document.removeEventListener("visibilitychange", alVolver);
    };
  }, [revisar]);

  if (!versionNueva) return null;

  const actualizarSinCache = () => {
    const url = new URL(window.location.href);
    url.searchParams.set(
      "_version",
      versionNueva.compilado || versionNueva.sha || Date.now().toString()
    );
    window.location.replace(url.toString());
  };

  const cerrar = () => {
    setVersionDescartada(identidadDe(versionNueva));
    setVersionNueva(null);
  };

  return (
    <div className="aviso_version_nueva" role="status">
      <span>Hay una versión nueva del sistema. Actualizá para verla.</span>
      <button type="button" onClick={actualizarSinCache}>
        Actualizar
      </button>
      <button
        type="button"
        className="aviso_version_nueva__cerrar"
        onClick={cerrar}
        aria-label="Cerrar el aviso"
      >
        ×
      </button>
    </div>
  );
};

export default AvisoVersionNueva;
